/* eslint new-parens: 0 */
/* globals EasyPost Backbone*/
import { setLocation } from 'utils/wrappers';
import Base from 'app/routers/base';
import PasswordResetRequestPage from 'app/views/password_reset_request_page';
import PasswordResetPage from 'app/views/password_reset_page';
import ShippingCalculatorPage from 'app/views/shipping_calculator_page';
import LoginView from 'app/views/login_view';
import UserCreateView from 'app/views/user_create_view';
import TalkToEasyPostPage from 'app/views/talk_to_easypost_page';
import VerificationSplashPage from 'app/views/verification_splash_page';
import VerificationSubmitPage from 'app/views/verification_submit_page';
import JobsPage from 'app/views/jobs_page';
import PurchaseConfirmationPage from 'app/views/purchase_confirmation_page';
import CheckoutSuccessPage from 'app/views/checkout_success_page';
import USPSZoneLookupPage from 'app/views/usps_zone_lookup_page';

const DefaultRouter = Base.extend({
  routes: {
    reset: 'requestPasswordResetEmail',
    'reset-confirmation': 'passwordResetConfirmation',
    'shipping-calculator': 'calculator',
    signin: 'signin',
    signup: 'signup',
    'checkout/signup': 'signupForCheckout',
    'checkout/signin': 'signinForCheckout',
    'checkout/confirmation': 'purchaseConfirmation',
    'checkout/success': 'checkoutSuccess',
    'talk-to-easypost': 'contact',
    verification: 'verificationSplash',
    jobs: 'jobsPage',
    'jobs.html': 'jobsPage',
    'usps-zone-lookup': 'uspsZoneLookupPage',
    'usps-zone-lookup.html': 'uspsZoneLookupPage',
  },
  verificationSplash() {
    // we can't have dynamic pages with our static site, so must look for the location hash
    const code = this.checkForHash();
    if (this.enforceNotLoggedIn()) {
      if (code.length) {
        this.renderView(new VerificationSubmitPage({ code }));
      } else {
        this.renderView(new VerificationSplashPage({}));
      }
    }
  },
  contact() {
    this.renderView(new TalkToEasyPostPage({}));
  },
  signup() {
    if (this.enforceNotLoggedIn()) {
      this.renderView(new UserCreateView());
    }
  },
  signupForCheckout() {
    if (this.enforceCheckoutFlow() && this.enforceNotLoggedIn()) {
      this.renderView(new UserCreateView({ redirect: '/checkout/confirmation#new' }));
    }
  },
  signin() {
    if (this.enforceNotLoggedIn()) {
      this.renderView(new LoginView({}));
    }
  },
  signinForCheckout() {
    const confirmationPage = '/checkout/confirmation';
    if (this.enforceCheckoutFlow() &&
        this.enforceNotLoggedIn(setLocation.bind(this, confirmationPage))) {
      this.renderView(new LoginView({ redirect: confirmationPage }));
    }
  },
  calculator() {
    this.renderView(new ShippingCalculatorPage({}));
  },
  requestPasswordResetEmail() {
    if (this.enforceNotLoggedIn()) {
      this.renderView(new PasswordResetRequestPage({}));
    }
  },
  passwordResetConfirmation() {
    const token = this.checkForHash();
    if (token.length) {
      this.renderView(new PasswordResetPage({ token }));
    } else {
      setLocation('/reset');
    }
  },
  jobsPage() {
    this.renderView(new JobsPage({}));
  },
  purchaseConfirmation() {
    const hash = this.checkForHash();
    const callback = this.renderView.bind(this,
      new PurchaseConfirmationPage());
    if (this.enforceCheckoutFlow()) {
      if (hash && hash.replace(/\?.*/, '') === 'new') {
        callback();
      } else {
        this.enforceLogin(callback, '/checkout/signup');
      }
    }
  },
  checkoutSuccess() {
    if (this.enforceCheckoutFlow()) {
      if (EasyPost.Globals.firstFetchComplete) {
        this.renderView(new CheckoutSuccessPage({ userLoggedIn: this.userIsLoggedIn() }));
      } else {
        EasyPost.Globals.currentUser.once('error sync', () => {
          this.renderView(new CheckoutSuccessPage({ userLoggedIn: this.userIsLoggedIn() }));
        });
      }
    }
  },
  uspsZoneLookupPage() {
    this.renderView(new USPSZoneLookupPage({}));
  },
});

export default DefaultRouter;



// WEBPACK FOOTER //
// ./app/routers/default_router.js